import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { utils } from '@atlaskit/util-service-support';
import { packageName, packageVersion } from '../constants';
export var markNotificationGroupRoute = '/gateway/api/notification-log/api/3/notification-groups/';
export default function markNotificationGroupFetch(_x, _x2, _x3) {
  return _markNotificationGroupFetch.apply(this, arguments);
}
function _markNotificationGroupFetch() {
  _markNotificationGroupFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee( /** Indicates the groupId of the notifications that should be updated */
  groupId, /** The id of the notification that indicates the starting point of which notifications should be updated */
  afterInclusive, /** The read state the notifications should be updated to */
  toState) {
    var requestServiceOptions, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          requestServiceOptions = {
            queryParams: {
              afterInclusive: afterInclusive
            },
            requestInit: {
              credentials: 'include',
              headers: {
                'content-type': 'application/json',
                'x-app-name': packageName,
                'x-app-version': packageVersion
              },
              method: 'POST',
              body: JSON.stringify({
                toState: toState
              })
            }
          };
          url = markNotificationGroupRoute + encodeURIComponent(groupId) + '/mark';
          return _context.abrupt("return", utils.requestService({
            url: url
          }, requestServiceOptions));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _markNotificationGroupFetch.apply(this, arguments);
}